import {createAction, props} from '@ngrx/store';
import {CourseCoupon} from '../models/coupon.model';
import {Update} from '@ngrx/entity';


export const loadCoupons = createAction(
  '[Edit Course Screen]  Load Coupons',
  props<{activeCouponsOnly:boolean }>()
);

export const addCoupons = createAction(
  '[Coupon] Add Coupons',
  props<{ coupons: CourseCoupon[] }>()
);

export const deleteCoupon = createAction(
  '[Coupon] Delete Coupon',
  props<{ courseId:string, couponId:string }>()
);

export const deleteCouponSuccess = createAction(
  '[Coupon] Delete Coupon Success',
  props<{ couponId:string }>()
);

export const addCoupon = createAction(
  '[Coupon] Add Coupon',
  props<{ coupon: CourseCoupon }>()
);



export const updateCoupon = createAction(
  '[Coupon] Update Coupon',
  props<{ courseId:string, coupon: Update<CourseCoupon> }>()
);



export const loadCoupon = createAction(
  '[Course Page] Load Coupon',
  props<{courseId:string; couponCode:string}>()
);



export const loadCouponCompleted = createAction(
  '[Load Coupon Effect] Load Coupon Completed',
  props<{ coupon: CourseCoupon }>()
);



